import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ToastProvider } from './components/ui';
import { AuthProvider } from './lib/auth';
import { initInstall } from './lib/install';
import { ScopeProvider } from './lib/scope';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 15_000,
    },
  },
});

// Das Installationsangebot des Browsers kommt frueh - vor dem ersten Rendern abfangen.
initInstall();
// Der Service Worker bringt Push und die App-Huelle fuer den Start ohne Netz (public/sw.js).
// updateViaCache: Das Skript selbst kommt nie aus dem HTTP-Zwischenspeicher - eine neue Version wird sofort bemerkt.
if ('serviceWorker' in navigator) {
  void navigator.serviceWorker
    .register('/sw.js', { scope: '/', updateViaCache: 'none' })
    .then((registration) => {
      // Eine lange offene App (Home-Bildschirm) prueft beim Zurueckkehren, ob es eine neue Version gibt.
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') void registration.update().catch(() => undefined);
      });
    })
    .catch(() => undefined);
}

const container = document.getElementById('root');
if (!container) throw new Error('Wurzelelement nicht gefunden');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <AuthProvider>
            <ScopeProvider>
              <App />
            </ScopeProvider>
          </AuthProvider>
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
